<template>
  <div selenium="footer">
    <client-only>
      <app-footer-upper v-if="!isPro"/>
    </client-only>
    <app-footer-lower/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AppFooterLower from '@/layouts/components/AppFooterLower';
import AppFooterUpper from '@/layouts/components/AppFooterUpper';

export default {
  name: 'app-footer',
  components: {
    AppFooterLower,
    AppFooterUpper,
  },
  computed: {
    ...mapGetters('user', [
      'isPro',
      'isLoggedIn',
    ]),
  },
};
</script>
